import { ApiError } from '@eneco/dc/client/ApiError';
import { discontinue } from '@eneco/dc/services/smartthermostat';
import { DiscontinueReason, ResponseDataOfDiscontinueResponse } from '@monorepo-types/dc/smartthermostat';

import {
  CancellationOverviewFetchValues,
  createCancellationOverviewMachineWithSubmit,
} from './cancellationOverviewMachine';
import { MachineConfig } from '../types';

interface SmartThermostatCancellationSubmitValues extends CancellationOverviewFetchValues {
  reasonCode?: DiscontinueReason;
  explanation?: string;
  referenceId?: string;
}

const thermostatCancelation = (
  config: MachineConfig,
  reasonInformation: SmartThermostatCancellationSubmitValues,
): Promise<ResponseDataOfDiscontinueResponse> => {
  const requestBody = {
    data: {
      date: new Date().toISOString(),
      reasonCode: reasonInformation.reasonCode as DiscontinueReason,
      referenceId: reasonInformation.referenceId ?? '',
      explanation: reasonInformation.explanation ?? '',
    },
  };

  return new Promise((resolve, reject) =>
    discontinue({
      businessUnit: config.businessUnit,
      label: config.label,
      customerId: Number(reasonInformation.customerId),
      accountId: Number(reasonInformation.accountId),
      requestBody,
    })
      .then(response => {
        resolve(response);
      })
      .catch((error: ApiError) => {
        reject(new Error(error?.message));
      }),
  );
};

export const createSmartThermostatCancellationOverviewMachine = () =>
  createCancellationOverviewMachineWithSubmit<SmartThermostatCancellationSubmitValues>(thermostatCancelation);
